// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".save-search-picker-filter {\n  width: 75%;\n  display: inline-block;\n}\n\n.save-search-picker-search {\n  width: 100%;\n  display: inline-block;\n}\n\n@media (max-width: 700px) {\n  .save-search-picker-filter {\n    width: 65%;\n    display: inline-block;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
